import { useQuery, useQueryClient } from '@tanstack/react-query'
import { LoadingState } from '@cinesend/ui-kit'
import FieldValue from '../field_value'
import SettingsCard from '../settings_card'
import { DETAILS_FIELD_NAMES, fieldOrderIn, matchesFieldName } from './field_groups'

const DetailsFields = ({ asset, cycleID }) => {
  const queryClient = useQueryClient()
  const standardKey = [`field-values`, `?assetID=${asset.id}`, `&cycleID=${cycleID}`, `&isStandard=true`]
  const commonKey = [`field-values`, `?assetID=${asset.id}`, `&cycleID=${cycleID}`]
  const { data: standardFields, isLoading: isStandardLoading } = useQuery(standardKey)
  const { data: commonFields, isLoading: isCommonLoading } = useQuery(commonKey)

  const refreshValues = () => {
    queryClient.invalidateQueries(standardKey)
    queryClient.invalidateQueries(commonKey)
  }

  if (isStandardLoading || isCommonLoading) {
    return (
      <SettingsCard title='Details'>
        <LoadingState className='justify-center' />
      </SettingsCard>
    )
  }

  const selected = []
  const seen = new Set()
  for (const [fields, cacheKey] of [
    [standardFields, standardKey],
    [commonFields, commonKey],
  ]) {
    for (const field of fields ?? []) {
      if (!matchesFieldName(DETAILS_FIELD_NAMES, field.name)) continue
      if (seen.has(field.id)) continue
      seen.add(field.id)
      selected.push({ field, cacheKey })
    }
  }
  selected.sort(
    (a, b) => fieldOrderIn(DETAILS_FIELD_NAMES, a.field.name) - fieldOrderIn(DETAILS_FIELD_NAMES, b.field.name)
  )

  if (selected.length === 0) return null

  return (
    <SettingsCard title='Details'>
      <div className='grid gap-4 sm:grid-cols-2'>
        {selected.map(({ field, cacheKey }) => (
          <div key={field.id} id={`field-${field.name?.toLowerCase()?.replaceAll(' ', '-')}`}>
            <FieldValue
              cacheKey={cacheKey}
              field={field}
              assetID={asset.id}
              cycleID={cycleID}
              refreshValues={refreshValues}
            />
          </div>
        ))}
      </div>
    </SettingsCard>
  )
}

export default DetailsFields
